'use client';

import { useEffect, useState, useRef } from 'react';
import PageLoader from '@/components/common/PageLoader';

interface PageLoaderWrapperProps {
  children: React.ReactNode;
}

export default function PageLoaderWrapper({ children }: PageLoaderWrapperProps) {
  const [isLoading, setIsLoading] = useState(true);
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;

    // Hide loader after first paint + hydration
    // Use double RAF to ensure content has painted
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (mountedRef.current) {
          setIsLoading(false);
        }
      });
    });

    // Hard maximum: loader MUST be gone by 1200ms
    const maxTimeout = setTimeout(() => {
      if (mountedRef.current) {
        setIsLoading(false);
      }
    }, 1200);

    return () => {
      mountedRef.current = false;
      clearTimeout(maxTimeout);
    };
  }, []);

  return (
    <>
      {/* Content renders immediately - no gating */}
      {children}
      {/* Loader is a non-blocking overlay */}
      <PageLoader isLoading={isLoading} />
    </>
  );
}